import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => ({
        url: urls.users,
        params,
      }),
    }),
    getUser: builder.query({
      query: (id) => ({
        url: urls.userDetail(id),
      }),
    }),
    getUsersByIds: builder.query({
      query: (userIds) => ({
        url: urls.usersStack,
        method: 'GET',
        params: { userIds: userIds.join(',') },
      }),
    }),
    getTeachers: builder.query({
      query: (params) => ({
        url: urls.teachers,
        params,
      }),
    }),
    getResponsibleUsers: builder.query({
      query: () => ({
        url: `${urls.users}?responsibleArticles=true`,
      }),
    }),
    getStudentUsers: builder.query({
      query: () => ({
        url: urls.studentUsers,
      }),
    }),
    getNewsUsers: builder.query({
      query: () => ({
        url: urls.newsUsers,
      }),
    }),
    getArticleAuthors: builder.query({
      query: () => ({
        url: urls.articleAuthors,
      }),
    }),
    saveUser: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.userDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        }
      },
    }),
    updateLoggedUser: builder.mutation({
      query(req) {
        return {
          url: urls.userDetail(req.id),
          method: 'PUT',
          data: req.body,
        };
      },
    }),
    deleteUser: builder.mutation({
      query(id) {
        return {
          url: urls.userDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useGetUsersByIdsQuery,
  useGetStudentUsersQuery,
  useGetTeachersQuery,
  useGetNewsUsersQuery,
  useGetArticleAuthorsQuery,
  useGetResponsibleUsersQuery,
  useSaveUserMutation,
  useUpdateLoggedUserMutation,
  useDeleteUserMutation,
} = usersApi;
